
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import allConfigTable from "./all-config-table.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-all-config-table": allConfigTable
  }
})
export default class PiAllConfig extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private gradeList!: objAny[];
  @Prop({
    default: () => {
      return [];
    }
  })
  private typeList!: objAny[];
  private tabsList: object[] = [
    { name: "tab1", title: i18n.t("alarmSet.alarmLevel"), value: 1 },
    { name: "tab2", title: i18n.t("alarmSet.alarmType"), value: 2 }
  ];
  private tabsActive = "tab1";
  public tabChange(data: string): void {
    this.tabsActive = data;
    if (data == "tab2" && !this.tab2) {
      this.tab2 = true;
    }
  }
  private tab1 = false;
  private tab2 = false;
  private modalShow = false;
  private modalTitle = i18n.t("alarmSet.allConfig");
  public open() {
    this.modalShow = true;
    this.tab1 = true;
  }
  public success() {
    this.$emit("success");
  }
}
